import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Injectable } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import * as _moment from "moment";
import { default as _rollupMoment } from "moment";
import { columnsDef } from "../interfaces/columnsDef";
import { FormItemConfiguration } from "../system-utils/form-item-component/form-item-component.component";
import { WebhookField } from "../webhook-creator/webhook-creator/webhook-interfaces/configuration";
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";
import { LanguageServices } from "./LanguageServices";

const moment = _rollupMoment || _moment;

@Injectable({
  providedIn: "root",
})
export class FormServices {
  refreshPk(formGroup: UntypedFormGroup, data: Object) {
    Object.keys(data).forEach((col) => {
      try {
        formGroup.get(col).patchValue(data[col]);
      } catch (Exception) {}
    });
  }

  refreshRowPk(rows: Object, data: Object) {
    Object.keys(rows).forEach((col) => {
      rows[col] = data[col];
    });
  }

  constructor(private datePipe: DatePipe, private ls:LanguageServices, private fb:FormBuilder) {}
  public cd: ChangeDetectorRef;

  public refreshForm(
    formGroup: UntypedFormGroup,
    tableInformation: columnsDef[],
    row: Object = null,
    addingNewRow: boolean
  ): void {
    tableInformation.forEach((x: columnsDef) => {
      this.addControl(x, formGroup, addingNewRow, row);
    });

    if (this.cd != null) {
      this.cd.markForCheck();
    }
  }

  public addControl(x: columnsDef, formGroup:UntypedFormGroup, addingNewRow: boolean, row: Object){

    let temRef: string = Object.keys(x).find((k: string, index: number) => {
      if (k.startsWith("MKTPDICREF")) {
        return true;
      }
    });

    let disabled: boolean =
      x.ISIDENTITY == 1 ||
      //(x.ISPK == 1 && x.ISFK == 1 &&  !addingNewRow ) ||
      (x.ISPK == 1 && !addingNewRow) ||
      x.INCREMENTALFIELD == 1 ||
      x.ISREADONLY == 1;
    let required: boolean =
      x.ISREQUIRED == 1 || x.ISNULLABLE == 0 ? true : false;
    
    let size:number = x.COLSIZE;

    if (x.DATATYPE == "DATETIME") {
      if (!addingNewRow) {
        formGroup.addControl(
          x.COLUMNNAME,
          new UntypedFormControl({ value: row[x.COLUMNNAME], disabled: disabled })
        );
      } else {
        formGroup.addControl(
          x.COLUMNNAME,
          new UntypedFormControl({ value: null, disabled: disabled })
        );
      }
    } else {
      if (
        x.COLUMNNAME.indexOf("->") > -1 &&
        x.DATATYPE != "SEARCHREFERENCE"
      ) {
        if (!formGroup.contains(x.COLUMNNAME)) {
          formGroup.addControl(
            x.COLUMNNAME,
            new UntypedFormControl({ value: null, disabled: disabled })
          );
        }

        if (!addingNewRow) {
          formGroup.get(x.COLUMNNAME).patchValue(row[x.COLUMNNAME]);
        }
      } else {
        if (x.DATATYPE == "SEARCHREFERENCE") {
          if (x.COLUMNNAME.indexOf("->")) {
            
            let col = x.COLUMNNAME.split("->")[0];

            if ( x.headerName != null ){
              col = x.headerName;
            }
            
            formGroup.addControl(
              col,
              new UntypedFormControl({ value: null, disabled: disabled })
            );
            formGroup.addControl(
              x.COLUMNNAME,
              new UntypedFormControl({ value: null, disabled: disabled })
            );

            try{
              if ( formGroup.get(col).disabled ){
                formGroup.get(x.COLUMNNAME).disable();
              }else{
                  formGroup.get(x.COLUMNNAME).enable();
              }
            }catch(e){}
            
            
          }
        } else {
          if (!formGroup.contains(x.COLUMNNAME)) {
            formGroup.addControl(
              x.COLUMNNAME,
              new UntypedFormControl({ value: null, disabled: disabled })
            );
          }

          if (!addingNewRow) {
            formGroup.get(x.COLUMNNAME).patchValue(row[x.COLUMNNAME]);
          }
        }
      }
    }

    let arrayValidors = [];
    if (required) {
      arrayValidors.push(Validators.required);
    }

    if (x.DATATYPE == "VARCHAR" || x.DATATYPE == "CHAR") {
      if (size > 0) {
        arrayValidors.push(Validators.maxLength(size));
      }
    }

    if (x.DATATYPE == "INT") {
      arrayValidors.push(Validators.pattern("^-?[0-9]+$"));
    }

    if (arrayValidors.length > 0) {
      if (x.COLUMNNAME.indexOf("->") == -1) {
        formGroup.get(x.COLUMNNAME).setValidators(arrayValidors);
        formGroup.get(x.COLUMNNAME).updateValueAndValidity();
      }
    }
  }

  public removeIndentityFields(
    ob: Object,
    tableInformation: columnsDef[]
  ): Object {
    tableInformation.forEach((columnsDef) => {
      if (columnsDef.ISIDENTITY == 1) {
        delete ob[columnsDef.COLUMNNAME];
      }
    });

    return ob;
  }

  public refreshFormObject(form:UntypedFormGroup, row:Object, changeNull:boolean = true, emitEvent:boolean = true){
      Object.keys(row).forEach(col=>{
          try{
              if ( (row[col] == null && changeNull )|| row[col]!= null){
                form.get(col).setValue(row[col])
              }
              
          }catch(Exception ){
          }
      })
  }


  public refreshFormWithCreationObject(form:UntypedFormGroup, row:Object, changeNull:boolean = true){
    
    Object.keys(row).forEach(col=>{
        try{
            if ( (row[col] == null && changeNull )|| row[col]!= null){
              if ( form.get(col)== null){
                form.addControl(col,new FormControl(null));
              }
              form.get(col).setValue(row[col])
            }
            
        }catch(Exception ){
        }
    })
}

  public getFormErrors(formGroup:FormGroup<any>, tableInformation:any[],lineBreak?:string, lsPrefix:string = null):string{

    let object = this.getAllErrors(formGroup);
   
    if ( object!= null ){
      return this.translateErrors(object,tableInformation,lineBreak,lsPrefix);
    }
  }


  getAllErrors(form: UntypedFormGroup | UntypedFormArray): { [key: string]: any } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors =
        control instanceof UntypedFormGroup || control instanceof UntypedFormArray
          ? this.getAllErrors(control)
          : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any });
    return hasError ? result : null;
  }

  private translateErrors(object, tableInformation:columnsDef[]|{colName:string,colDesc:string}[]|FormItemConfiguration[]|WebhookField[],lineBreak:string="\n", lsPrefix:string = null):string{
    let message:string='';

    if ( tableInformation.length> 0 &&tableInformation[0]['label'] != null){
      return this.translateErrors2(object,tableInformation as WebhookField[],lineBreak);
    }


    Object.keys(object).forEach(dt=>{
        let columnDesc:string = dt;
        if ( tableInformation.length > 0 && tableInformation[0]['COLUMNNAME'] != null){
          let info = (tableInformation as columnsDef[]).find((d:columnsDef)=>d.COLUMNNAME==dt);
          if ( info != null ){
            columnDesc = info.COLUMNDESC;  
          }
        }else{
          if (  tableInformation.length > 0 && tableInformation[0]['name'] != null){
            let info = (tableInformation as FormItemConfiguration[]).find(d=>d.name==dt);
            if ( info!= null ){
              columnDesc = info.title;
            }
          }else{
            if ( tableInformation.length > 0 && tableInformation[0]['colName'] != null){
              let info = (tableInformation as {colName:string,colDesc:string}[]).find(d=>d.colName==dt);
              if ( info!= null ){
                columnDesc = info.colDesc;
              }
            }else{
              columnDesc = lsPrefix ? lsPrefix +'.'+ dt : dt;
            }
          
          }
        }
        
        message = message+ '⚠️ '+this.ls.instant('forms.error.field')+ ' ' +this.ls.instant(columnDesc)  + ' ' +this.errorType(object[dt])+lineBreak;
    });
    return message;
  }


  private translateErrors2(object, tableInformation:WebhookField[],lineBreak:string="\n"):string{
    let message:string='';
    let columnDesc:string = '';
    let path = "";
    let errorType = "";
    let i = 0;
    
    let paths:any[] = ObjectUtil.objectToDotPaths(object);


    paths.forEach(data=>{
      path = data.path;
      errorType = data.value;
      
      let info = (tableInformation as WebhookField[]).find(d=>d.field==path);
      
      if ( info!= null ){
        columnDesc = info.label;
      }else{
        columnDesc = path;
      }
      
      message = message+ '⚠️ '+this.ls.instant('forms.error.field')+ ' ' +this.ls.instant(columnDesc)  + ' ' +this.errorType(errorType)+lineBreak;
      
    });
    
    return message;
  }

  private errorType(data){
    let error = '';
    Object.keys(data).forEach(k=>{
      
        if ( k=='required'){
            if (data[k]){
              error= this.ls.instant('forms.error.isrequired');
            }             
        }else
        if ( k=='maxlength'){
          let atual:number = data[k]['actualLength'];
          let required:number = data[k]['requiredLength'];
          if (data[k]){
            error= this.ls.instant('forms.error.max',{atual:atual,required:required});// ` com quantidade maior que o permitido (Quantidade Atual: ${atual} - Quantidade Máxima: ${required}).`;
          }             
        }else

        if ( k=='minlength'){
          let atual = data[k]['actualLength'];
          let required = data[k]['requiredLength'];
          if (data[k]){
            error = this.ls.instant('forms.error.min',{atual:atual,required:required}); //` com quantidade menor que o permitido (Quantidade Atual: ${atual} - Quantidade Mínima: ${required}).`;
          }             
        }

        else{
            error = JSON.stringify(k);
        }

    })
    return error;
  }
  

  public patchForm(data: any, formGroup: FormGroup) {
       
        Object.keys(data).forEach(key => {
            const control = formGroup.get(key);
            if (control instanceof FormControl) {
                control.setValue(data[key]);
            } else if (control instanceof FormGroup) {
                if ( Object.entries(data[key]).length>0  ){
                    Object.keys(data[key]).forEach(d=>{
                        if ( d != null ){
                            if (  Array.isArray(data[key][d]) ){
                                const formArray = new FormArray([]);
                                data[key][d].forEach(item => {
                                    const group = this.fb.group({});
                                    Object.keys(item).forEach(k => {
                                        group.addControl(k, this.fb.control(item[k]));
                                    });
                                    formArray.push(group);
                                });
                                control.addControl(d, formArray);
                            }else{
                              const formControl = new FormControl<any>(data[key][d]);
                              control.addControl(d,formControl);
                            }
                            
                        }
                    });
                }else{
                    this.patchForm(data[key], control);
                }
                this.patchForm(data[key], control);
                
            } else if (control instanceof FormArray && Array.isArray(data[key])) {
            
                    control.clear(); // clear existing controls
                
                    data[key].forEach((item: any) => {
                    // Assume each item is an object → FormGroup
                        const group = this.fb.group({});
                        Object.keys(item).forEach(k => {
                        group.addControl(k, this.fb.control(item[k]));
                    });
                    control.push(group);
                });
            }
        });
    }

    patchRecursive(target: FormGroup | FormArray, source: FormGroup | FormArray): void {
      Object.keys(source.controls).forEach(key => {
        const sourceControl = source.get(key);
        const targetControl = target.get(key);

        if (!targetControl || !sourceControl) return;

        if (sourceControl instanceof FormGroup && targetControl instanceof FormGroup) {
          this.patchRecursive(targetControl, sourceControl);
        } else if (sourceControl instanceof FormArray && targetControl instanceof FormArray) {
          
          targetControl.clear();
          sourceControl.controls.forEach((ctrl, index) => {
            if (ctrl instanceof FormGroup) {
              const newGroup = new FormGroup({});
              this.patchRecursive(newGroup, ctrl);
              targetControl.push(newGroup);
            } else {
              targetControl.push(new FormControl(ctrl.value));
            }
          });
        } else {
            targetControl.setValue(sourceControl.value);
        }
      });
    }

}
